import "core-js/modules/es.array.push.js";
import vailcode from "@utils/errcode";
export default {
  name: "nft",
  data() {
    const NFTMenu = [{
      label: "Buy Shards",
      value: "buyNFTShards",
      icon: require("@images/tapcoin/new/niceLucky/icon-buy.png"),
      path: "popNFTShardsShow",
      type: "pop"
    }, {
      label: "Shard Draw",
      value: "shardDraw",
      icon: require("@images/tapcoin/new/niceLucky/icon-shard.png"),
      path: "/nftLucky",
      type: "router"
    }, {
      label: "Tasks",
      value: "task",
      icon: require("@images/tapcoin/new/niceLucky/icon-task.png"),
      path: "popNFTTaskShow",
      type: "pop"
    }, {
      label: "Invite",
      value: "invite",
      icon: require("@images/tapcoin/new/niceLucky/icon-invite.png"),
      path: "/nftInvite",
      type: "router"
    }];
    return {
      NFTMenu,
      popNFTShardsShow: false,
      popNFTTaskShow: false,
      NFTBalance: 0,
      NFTPricesList: null,
      myNFTList: null,
      myNFTListPage: {
        page: 1,
        limit: 50,
        isLoading: false,
        totalPages: 1
      },
      popRewardShow: false,
      rewardData: null,
      popNftDetailShow: false,
      nftDetail: null,
      iscraftLoading: false,
      popNFTInfoShow: false,
      popObtainNextTimeShow: false
    };
  },
  methods: {
    onQuest() {
      console.log(3333);
      this.popNFTInfoShow = true;
    },
    onMenu(item) {
      if (item.type == "router") {
        this.$router.push(item.path);
      } else if (item.type == "pop") {
        this[item.path] = true;
      }
    },
    async initFn() {
      await this.getNFTBalance();
      await this.getMyNFT(1, this.myNFTListPage.limit);
      await this.getNFTPricesList();
    },
    async getNFTBalance() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/nft/fragment/balance", {
          provider: "official",
          type: 3
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.NFTBalance = data.balance;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getNFTPricesList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/nft/fragment/prices", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.NFTPricesList = data.map(item => {
            return {
              ...item,
              isLoading: false,
              isCheckLoading: false,
              paymentId: null
            };
          });
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getMyNFT(page = 1, limit = 50) {
      this.myNFTListPage.isLoading = true;
      const res = await _v.$http.post("/nft/my/nfts", {
        page,
        limit
      });
      return new Promise(resolve => {
        vailcode(res, () => {
          const items = res.data.items || [];
          if (page === 1) {
            this.myNFTList = items;
          } else {
            this.myNFTList.push(...items);
          }
          this.myNFTListPage.totalPages = res.data.lastPage;
          this.myNFTListPage.page = page;
          this.myNFTListPage.isLoading = false;
          resolve(items);
        }, () => {
          this.myNFTListPage.isLoading = false;
          resolve([]);
        });
      });
      // return new Promise(async (resolve) => {
      //   vailcode(
      //     res,
      //     () => {
      //       const data = res.data;
      //       if (!data) {
      //         resolve();
      //         return;
      //       }
      //       this.myNFTList = data;
      //       resolve(data);
      //     },
      //     () => {
      //       resolve();
      //     }
      //   );
      // });
    },

    async craftNFT() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/nft/compose", {});
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: {
        //     balance: 890,
        //     nft: {
        //       id: 395,
        //       nft_id: "1000395",
        //       image_url: "https://static.tapcoins.app/nft_cats/1000395.png",
        //       name: "MetaCats #1000395",
        //       description: "MetaCats is more than just collectible NFTs - they're your ticket to unlock missions, events, and perks within the TapCoins universe. Join the squad, earn, evolve, and conquer.",
        //       star: 1,
        //       rarity_score: 4420,
        //       is_use: 0,
        //       attributes: {
        //         Bg: {
        //           value: "Bg green",
        //           rarity: 16.144,
        //         },
        //         Skin: {
        //           value: "Dark chocolate",
        //           rarity: 4.386,
        //         },
        //         Mouth: {
        //           value: "Complacent",
        //           rarity: 3.036,
        //         },
        //         Clothing: {
        //           value: "Bucket",
        //           rarity: 3.434,
        //         },
        //         Eyes: {
        //           value: "Crying",
        //           rarity: 5.164,
        //         },
        //         Head: {
        //           value: "Ufo",
        //           rarity: 8.62,
        //         },
        //         Items: {
        //           value: "Fan",
        //           rarity: 7.366,
        //         },
        //       },
        //     },
        //   },
        // };
        if (!res) {
          resolve();
          return;
        }
        if (res.code == 402) {
          this.popObtainNextTimeShow = true;
          resolve();
          return;
        }
        if (res.code > 0) {
          this.$toasted.error(res.message);
          resolve();
          return;
        }
        const data = res.data;
        if (!data) {
          resolve();
          return;
        }
        resolve(data);
      });
    },
    async onCraft() {
      if (this.iscraftLoading) return;
      this.iscraftLoading = true;
      const res = await this.craftNFT();
      if (!res) {
        this.iscraftLoading = false;
        return;
      }
      const image = new Image();
      image.src = res.nft.image_url;
      image.onload = () => {
        const nftDetail = {
          ...res.nft,
          type: "compose"
        };
        this.nftDetail = encodeURIComponent(JSON.stringify(nftDetail));
        if (!this.myNFTList) {
          this.iscraftLoading = false;
          return;
        }
        this.NFTBalance = res.balance;
        this.popNftDetailShow = true;
        this.$nextTick(() => {
          this.$router.push(`/nftdetail?nft=${this.nftDetail}&type=1`);
        });
      };
    },
    onNftDetail(item) {
      const nftDetail = {
        ...item,
        type: null
      };
      this.nftDetail = encodeURIComponent(JSON.stringify(nftDetail));
      this.$nextTick(() => {
        this.$router.push(`/nftdetail?nft=${this.nftDetail}&type=0`);
      });
    },
    popRewardFinish(data) {
      if (data?.newBalance) {
        this.NFTBalance = data.newBalance;
      }
    },
    myNFTHandleScroll(e) {
      const el = e.target;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.myNFTListPage.isLoading && this.myNFTListPage.page < this.myNFTListPage.totalPages) {
        this.getMyNFT(this.myNFTListPage.page + 1, this.myNFTListPage.limit);
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.myNFTHandleScroll);
    this.initFn();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.myNFTHandleScroll);
  }
};